export const canUseDom = () => !!global;
export const isMobile = () => canUseDom() && global.innerWidth <= 1024;
export const nextTick = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, 1000 / 30);
  });
};
